module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (103).37980e3c.jpg";